<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      :checkbox-config="{ highlight: true }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            v-if="isAllShipment"
            effect="dark"
            placement="top"
            :content="$l('INDEX.btn_tips_view') || '查看'"
          >
            <i class="el-icon-view tool-btn" @click="$emit('detail', row)" />
          </el-tooltip>
          <el-tooltip
            v-if="!disabled"
            effect="dark"
            placement="top"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="$emit('openEditDialog', row)"
            />
          </el-tooltip>
          <el-tooltip
            v-if="!disabled && shipmentStatus == 'B'"
            effect="dark"
            placement="top"
            :content="$l('INDEX.btn_tips_del') || '删除'"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="$emit('submitDel', [row.shipmentBookingCode])"
            />
          </el-tooltip>
        </div>
      </template>
      <template v-slot:expandContent="{ row }">
        <ContainerTable
          :shipmentCode="row.shipmentCode"
          :shipmentBookingCode="row.shipmentBookingCode"
          ref="containerTable"
        />
      </template>
      <template v-slot:batchAmount="{ row }">
        <span>{{ row.v_batchPriceAmount || 0 }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:batchSalePrice="{ row }">
        <span>
          {{ row.v_batchSalePriceAmount || 0 }}{{ row.v_salesCurrencyUnit }}
        </span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import ContainerTable from '../container-table'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  components: { ContainerTable },
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    shipmentStatus: { type: String, default: '' },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
      },
    }
  },
  computed: {
    isAllShipment() {
      return this.$route.name == 'transport-allShipment-detail'
    },
    tableColumns() {
      return tableColumns(this)
    },
  },
  methods: {
    getCheckboxRecords() {
      return this.$refs.table.getCheckboxRecords()
    },
  },
}
</script>
